/**
 * Clasificacion del fallo al cargar la sesion, para que el guard sepa a donde mandar.
 *
 * El contrato de status lo fija el backend (PR #2521 de finnecto-api):
 *   403 -> credencial valida, este ambiente te rechaza (sin fila en la sociedad del
 *          Referer, o grupo de Cognito equivocado)
 *   401 -> no hay sesion utilizable (identidad desconocida, contrasena expirada,
 *          close_session)
 *
 * ponytail: discriminar SOLO por status. El campo `detail` viene traducido, y hay
 * precedente medido de por que eso rompe: utils/api.ts compara contra el literal
 * ingles "Password expired" y nunca matchea en espanol.
 */
export type SessionFailureKind = 'no-session' | 'environment-rejected'

/**
 * Devuelve null para todo lo que NO es accionable. Eso es deliberado: los errores
 * transitorios (500, red, sin response) se siguen silenciando como hoy, asi un
 * usuario ya autenticado no termina en login por un hipo del backend.
 */
export function classifySessionFailure(status: number | undefined): SessionFailureKind | null {
  if (status === 403) return 'environment-rejected'
  if (status === 401) return 'no-session'
  return null
}

export class SessionFailure extends Error {
  readonly kind: SessionFailureKind

  constructor(kind: SessionFailureKind) {
    super(`Session failure: ${kind}`)
    this.name = 'SessionFailure'
    this.kind = kind
  }
}

export function isSessionFailure(error: unknown): error is SessionFailure {
  return error instanceof SessionFailure
}
